"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputWidths = void 0;
// since inputs behave differently than most other dom elements, segrigating possible widths to here for now
var inputWidths = {
  default: 'default',
  fitText: 'fitText'
};
exports.inputWidths = inputWidths;